import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { apiClient } from '../services/api.js';
import tokenService from '../services/tokenService.js';
import { logout } from '../store/slices/authSlice.js';
import { ROUTES } from '../constants/routes.js';

export default function RocheClaimsOS() {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  useEffect(() => {
    let cancelled = false;
    async function connect() {
      try {
        // The existing API client refreshes expired HarmonIQ tokens first.
        await apiClient.get('/auth/profile');
        const response = await fetch('/claims-api/api/demo/platform-session', {
          method: 'POST', headers: { Authorization: `Bearer ${tokenService.getAccessToken()}` },
        });
        if (!response.ok) throw new Error('Unable to open ClaimsOS. Please sign in again.');
        if (!cancelled) setReady(true);
      } catch (e) { if (!cancelled) setError(e.message); }
    }
    connect();
    const onMessage = (event) => {
      if (event.origin === window.location.origin && event.data === 'claimsos-signout') {
        dispatch(logout());
        window.location.assign(ROUTES.SIGN_IN);
      }
    };
    window.addEventListener('message', onMessage);
    return () => { cancelled = true; window.removeEventListener('message', onMessage); };
  }, [dispatch]);
  return (
    <div style={{height:'100dvh',display:'flex',flexDirection:'column',background:'#fff'}}>
      <header style={{height:48,padding:'0 20px',display:'flex',alignItems:'center',gap:24,borderBottom:'1px solid #ece5f4',flexShrink:0}}>
        <Link to={ROUTES.HOME} style={{color:'#7845C0',fontSize:13,textDecoration:'none'}}>← HarmonIQ Home</Link>
        <strong style={{fontSize:14}}>Roche ClaimsOS</strong>
        <span style={{marginLeft:'auto',fontSize:12,color:'#756887'}}>Not actual Roche data</span>
      </header>
      {error ? <p role="alert" style={{padding:24}}>{error}</p> : ready ?
        <iframe src="/claims-app/?embedded=1" title="Roche ClaimsOS application" style={{border:0,width:'100%',flex:1}} /> :
        <p role="status" style={{padding:24}}>Opening Roche ClaimsOS…</p>}
    </div>
  );
}
